enum ImageCroppie  {
  Notification = 'Notification',
  CustomTheme = 'CustomTheme',
  IconImage = 'IconImage',
}
export default Object.freeze(ImageCroppie);

